/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHemisphere = createReactComponent("outline", "hemisphere", "IconHemisphere", [["path", { "d": "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3 9a9 9 0 0 0 18 0", "key": "svg-1" }]]);

export { IconHemisphere as default };
//# sourceMappingURL=IconHemisphere.mjs.map
